// URLs y configuración de la aplicación
export const APP_CONFIG = {
  NAME: 'ARCA',
  PLAY_STORE_URL: import.meta.env.VITE_PLAY_STORE_URL || 'https://play.google.com/store/apps/details?id=com.arca.coronas',
  PACKAGE_NAME: import.meta.env.VITE_APP_PACKAGE_NAME || 'com.arca.coronas',
  SOCIAL_LINKS: {
    INSTAGRAM: 'https://www.instagram.com/coronasarca',
    TIKTOK: 'https://www.tiktok.com/@coronas.arca'
  }
}

// Configuración para integración con aplicación Android
export const ANDROID_APP = {
  ENABLED: import.meta.env.VITE_ANDROID_APP_ENABLED === 'true' || false,
  INTENT_BASE: 'intent://arca.app/',
  ACTIONS: {
    VIEW_PRODUCT: 'action=view_product',
    VIEW_CATEGORY: 'action=view_category',
    OPEN_CATALOG: 'action=open_catalog'
  },
  PLAY_STORE_URL: import.meta.env.VITE_PLAY_STORE_URL || 'https://play.google.com/store/apps/details?id=com.arca.coronas'
}

// Configuración de carruseles
export const CAROUSEL_CONFIG = {
  HOME_HERO: {
    AUTO_PLAY: true,
    DELAY: 3000, // 3 segundos
    LOOP: true
  },
  PRODUCTS: {
    AUTO_PLAY: false,
    LOOP: true,
    BREAKPOINTS: {
      320: { slidesPerView: 1, spaceBetween: 10 },
      640: { slidesPerView: 2, spaceBetween: 15 },
      768: { slidesPerView: 3, spaceBetween: 20 },
      1024: { slidesPerView: 4, spaceBetween: 25 },
      1280: { slidesPerView: 5, spaceBetween: 30 }
    }
  }
}

// Configuración de grid responsivo
export const GRID_CONFIG = {
  PRODUCTS: {
    DEFAULT: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4',
    LARGE: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
  }
}

// Configuración de animaciones
export const ANIMATION_CONFIG = {
  HOVER_SCALE: 'transform transition-all duration-300 hover:scale-105',
  FADE_IN: 'animate-fade-in',
  SLIDE_IN: 'animate-slide-in'
}

// Textos estáticos
export const STATIC_TEXTS = {
  BUTTONS: {
    BUY_APP: 'COMPRAR EN APP',
    BUY_APPLICATION: 'COMPRAR EN LA APLICACIÓN',
    EXPLORE: 'EXPLORAR',
    LEARN_MORE: 'Saber más'
  },
  MESSAGES: {
    LOADING: 'Cargando...',
    ERROR: 'Algo salió mal. Inténtalo de nuevo.',
    NO_PRODUCTS: 'No se encontraron productos.',
    NO_CATEGORIES: 'No se encontraron categorías.'
  }
}